import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import * as React from 'react';
import styled from '@emotion/styled';
import { transientOptions } from '../utils';
import { Tooltip, Typography as MuiTypography } from '@mui/material';
import LinesEllipsis from 'react-lines-ellipsis';
import TitleBar from '../TitleBar';
var StyledMuiTypography = styled(MuiTypography, transientOptions)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"])), function (_ref) {
  var $variant = _ref.$variant,
      color = _ref.color,
      sx = _ref.sx;
  return $variant === 'overline' && !color && !(sx !== null && sx !== void 0 && sx.color) ? "\n    && {\n      color: inherit;\n    }\n  " : '';
}, function (_ref2) {
  var $titleBar = _ref2.$titleBar;
  return $titleBar ? "\n          && {\n            display: flex;\n          }\n        " : '';
});

var Typography = function Typography(_ref3) {
  var body = _ref3.body,
      children = _ref3.children,
      color = _ref3.color,
      component = _ref3.component,
      display = _ref3.display,
      e2e = _ref3.e2e,
      gutterBottom = _ref3.gutterBottom,
      _ref3$tooltip = _ref3.tooltip,
      tooltip = _ref3$tooltip === void 0 ? '' : _ref3$tooltip,
      tooltipOpen = _ref3.tooltipOpen,
      variant = _ref3.variant,
      className = _ref3.className,
      _ref3$noWrap = _ref3.noWrap,
      noWrap = _ref3$noWrap === void 0 ? false : _ref3$noWrap,
      _ref3$truncated = _ref3.truncated,
      truncated = _ref3$truncated === void 0 ? false : _ref3$truncated,
      _ref3$tooltipOnlyWhen = _ref3.tooltipOnlyWhenTruncated,
      tooltipOnlyWhenTruncated = _ref3$tooltipOnlyWhen === void 0 ? false : _ref3$tooltipOnlyWhen,
      _ref3$maxLine = _ref3.maxLine,
      maxLine = _ref3$maxLine === void 0 ? 2 : _ref3$maxLine,
      _ref3$titleBar = _ref3.titleBar,
      titleBar = _ref3$titleBar === void 0 ? false : _ref3$titleBar,
      sx = _ref3.sx;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      clamped = _React$useState2[0],
      setClamped = _React$useState2[1];

  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    arrow: true,
    title: tooltip ? tooltip : truncated ? /*#__PURE__*/React.createElement(React.Fragment, null, body || children) : false
  }, tooltip && {
    open: tooltipOpen
  }, {
    disableHoverListener: tooltipOnlyWhenTruncated && !clamped || !tooltip && !clamped,
    disableTouchListener: tooltipOnlyWhenTruncated && !clamped || !tooltip && !clamped,
    PopperProps: _objectSpread(_objectSpread({}, e2e && {
      'data-e2e': "".concat(e2e, "-tooltip")
    }), {}, {
      modifiers: [{
        name: 'offset',
        options: {
          offset: [0, -8]
        }
      }]
    })
  }), /*#__PURE__*/React.createElement(StyledMuiTypography, _extends({
    color: color,
    display: display,
    $variant: variant,
    gutterBottom: gutterBottom,
    className: className,
    noWrap: noWrap,
    $titleBar: titleBar
  }, component && {
    component: component
  }, truncated && {
    component: 'div'
  }, e2e && {
    'data-e2e': e2e
  }, {
    variant: variant,
    sx: sx,
    ref: function ref(_ref4) {
      if (tooltipOnlyWhenTruncated && !truncated) {
        var _ref$parentElement, _ref$parentElement2;

        setClamped((_ref4 === null || _ref4 === void 0 ? void 0 : (_ref$parentElement = _ref4.parentElement) === null || _ref$parentElement === void 0 ? void 0 : _ref$parentElement.offsetWidth) !== (_ref4 === null || _ref4 === void 0 ? void 0 : (_ref$parentElement2 = _ref4.parentElement) === null || _ref$parentElement2 === void 0 ? void 0 : _ref$parentElement2.scrollWidth));
      }
    }
  }), titleBar && /*#__PURE__*/React.createElement(TitleBar, null), /*#__PURE__*/React.createElement("span", e2e && {
    'data-e2e': "".concat(e2e, "-body")
  }, truncated ? /*#__PURE__*/React.createElement(LinesEllipsis, {
    text: body || children,
    maxLine: maxLine,
    onReflow: function onReflow(state) {
      return setClamped(state.clamped);
    }
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, body, children))));
};

export default Typography;
//# sourceMappingURL=index.js.map